<template>
  <div>
    <v-toolbar flat color="white">
      <datepicker ref="datepicker" @update="record()"></datepicker>

      <v-spacer></v-spacer>
    </v-toolbar>

    <p v-if="errors.length">
      <v-alert :value="true" color="primary" type="error" dismissible outline>{{ errors }}</v-alert>
    </p>

    <v-data-table
      :headers="headers"
      :items="basket_record"
      active-class="highlighted"
      :disable-initial-sort="true"
      class="elevation-1"
    >
      <v-progress-linear v-show="isLoading"></v-progress-linear>

      <template slot="items" slot-scope="props">
        <td class="text-xs">
          <b>{{ props.item.created_at }}</b>
        </td>
        <td class="text-xs">{{ props.item.status }}</td>
        <td class="text-xs">{{ props.item.name }}</td>
        <td class="text-xs">{{ props.item.quantity }}</td>
        <td class="text-xs">{{ props.item.reason }}</td>
        <td class="text-xs">
          <v-icon medium color="error" @click="delete_basket(props.item.id)">delete_forever</v-icon>
        </td>
      </template>
    </v-data-table>

    <v-snackbar v-model="snackbar" :top="true">
      No Internet Connection
      <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-snackbar v-model="snackbar_message" :bottom="true" :multi-line="true" :timeout="3000">
      {{message}}
      <v-btn color="primary" flat @click="snackbar_message = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import axios from "axios";
import baseUrl from "@/api/baseurl";
import datepicker from "@/components/widget/datepicker";
import moment from "moment";

export default {
  components: {
    datepicker
  },
  data: () => ({
    search: "",
    isLoading: true,
    snackbar: false,
    snackbar_message: false,

    dialog: false,
    errors: "",
    baseUrl: baseUrl,
    date: moment().format("YYYY-MM-DD"),

    headers: [
      { text: "Date", align: "", value: "created_at" },
      { text: "Type", align: "", value: "status" },
      { text: "With", align: "", value: "name" },
      { text: "Quantity", align: "", value: "quantity" },
      { text: "Reason", align: "", value: "reason" },
      { text: "Action", align: "", value: "" }
    ],
    basket_record: []
  }),

  computed: {},

  watch: {},

  created() {
    this.initiaterecord();
  },

  methods: {
     initiaterecord() {
      const params = new URLSearchParams();

      params.append("ManualBasketRecord", "ManualBasketRecord");

      params.append("start_date", this.date);
      params.append("end_date", this.date);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/basket_manage/basket_manage.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.snackbar_message = false;
            this.basket_record = response.data.data;
            this.errors = "";
          } else if (response.data.error == true) {
            this.errors = response.data.message;
            this.basket_record = [];
            setTimeout(
              function() {
                this.errors = "";
              }.bind(this),
              6000
            );
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
    record() {
      const params = new URLSearchParams();

      params.append("ManualBasketRecord", "ManualBasketRecord");

      params.append("start_date", this.$refs.datepicker.date1);
      params.append("end_date", this.$refs.datepicker.date2);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/basket_manage/basket_manage.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.snackbar_message = false;
            this.basket_record = response.data.data;
            this.errors = "";
          } else if (response.data.error == true) {
            this.errors = response.data.message;
            this.basket_record = [];
            setTimeout(
              function() {
                this.errors = "";
              }.bind(this),
              6000
            );
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },
    delete_basket(id) {
      const params = new URLSearchParams();

      params.append("delete_basket", "delete_basket");
      params.append("id", id);

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/basket_manage/basket_manage.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.snackbar_message = true;
            this.message = response.data.message;
            this.record();
          } else if (response.data.error == true) {
            this.snackbar_message = true;
            this.message = response.data.message;
            this.record();
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    }
  }
};
</script>

